module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-preface element-with-heading",
    attrs: {
      "id": "preface"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "preface-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Preface")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "preface-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("In September 1938 Neville Chamberlain, the British Prime Minister, flew home from Munich waving a piece of paper containing Adolf Hitler’s promise not to go to war. Later he proclaimed from 10 Downing Street: ‘Peace with honour; peace for our time.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Less than a year later war was declared, Britain having given the Führer what he wanted at Munich, an important part of Czechoslovakia, which led directly, by a series of German aggressions, to the Second World War.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Verdict from veteran German watcher, US radio correspondent William Shirer: ‘The prime minister’s stubborn, fanatical insistence on giving Hitler what he wanted… added immeasurably to the power of the Third Reich. The calamitous consequences of the surrender were scarcely comprehended by Chamberlain but, strategically, France and Great Britain were worse off when war was declared in September 1939 than at the time of Munich in 1938.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Question: Why didn’t someone stop the arch-appeaser?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Answer: Someone tried…")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4736dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface.vue
// module id = 78
// module chunks = 0